import { render, staticRenderFns } from "./TransactionMenu.vue?vue&type=template&id=1df10d4a&scoped=true"
import script from "./TransactionMenu.vue?vue&type=script&lang=js"
export * from "./TransactionMenu.vue?vue&type=script&lang=js"
import style0 from "./TransactionMenu.vue?vue&type=style&index=0&id=1df10d4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df10d4a",
  null
  
)

export default component.exports